<!-- <img src="../../assets/blogimages/safety-101.png"> -->

<!-- ======= Blog Section ======= -->
<section id="blog" class="blog" style="padding-top: 170px;background-color: #f5f5f5;">
  <div class="container">

    <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'500px'" *ngIf="blogs===undefined"></ngx-shimmer-loading> -->

    <div class="row" *ngIf="blogs && blogs.length>0">
      <div class="col-lg-8 entries">
        <article class="entry entry-single" data-aos="fade-up" data-aos-delay="200" *ngFor="let blog of blogs">
          <div class="entry-img" (click)="goToDetailsPage(blog.id)">
            <img [src]="blog.image" alt="" class="img-fluid">
          </div>

          <h2 class="entry-title" (click)="goToDetailsPage(blog.id)">
            <a (click)="goToDetailsPage(blog.id)">{{blog.heading}}</a>
          </h2>

          <div class="entry-meta">
            <ul>
              <li class="d-flex align-items-center"><i class="fa fa-user"></i> <a>{{blog.by}}</a></li>
              <li class="d-flex align-items-center"><i class="fa fa-clock-o"></i> <a>{{blog.date}}</a></li>
              <!-- <li class="d-flex align-items-center"><i class="fa fa-folder"></i> <a>{{blog.category}}</a></li> -->
            </ul>
          </div>
          <div class="entry-content">
            <p [innerHtml]="blog.smalldescription">
            </p>
            <div class="read-more">
              <a (click)="goToDetailsPage(blog.id)">Read More</a>&nbsp;&nbsp;&nbsp;
              <a (click)="goToQuestionPage(blog.id)">Ask a Question</a>
            </div>
          </div>
        </article><!-- End blog entry -->

      </div><!-- End blog entries list -->

      <div class="col-lg-4" data-aos="fade-left" data-aos-delay="200">

        <div class="sidebar">
          <h3 class="sidebar-title">Search</h3>
          <div class="sidebar-item search-form">
            <input type="text" [(ngModel)]="searchHeading" class="form-control" placeholder="Search Blog" />
            <button (click)="search()" style="outline: none;"><i class="fa fa-search"></i></button>
          </div>
        </div>

        <!-- <div class="sidebar">
          <h3 class="sidebar-title">Categories</h3>
          <div class="sidebar-item categories">
            <ul>
              <li *ngFor="let cat of objCategory" (click)="onCheckboxClick(cat.category)"><a>{{cat.category}}</a></li>
            </ul>
          </div>
        </div> -->

        <div class="sidebar">
          <h3 class="sidebar-title">Recent Posts</h3>
          <div class="sidebar-item recent-posts">
            <div class="post-item clearfix" *ngFor="let blog of recentPost">
              <img [src]="blog.image" alt="">
              <h4><a (click)="goToDetailsPage(blog.id)">{{blog.heading}}</a></h4>
              <time datetime="2020-01-01">{{blog.date}}</time>
            </div>
          </div>

        </div>
      </div><!-- End blog sidebar -->

    </div>

    <div class="row" *ngIf="blogs && blogs.length===0">
      <div class="col-lg-12">
        <p>No Blogs Found</p>
        <button type="button" (click)="refresh()" class="btn btn-outline-primary btn-lg btn-block">Refresh</button>
        <p>{{wait}}</p>
      </div>
    </div>
  </div>
</section><!-- End Blog Section -->